import config from '@/config';
import { ROUTE_SHARE_BRIDGE } from '@/router/names';

export default [
    {
        path: '/share/:id',
        name: ROUTE_SHARE_BRIDGE,
        redirect: (to) => {
            const { id } = to.params;
            location.href = config.share.url(id);
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/share.js